// Per-page <title> + meta description/keywords + Open Graph, keyed by route.
const BRAND = "The Event Club";
const KEYWORDS = "video guestbook Vancouver, wedding video guestbook Lower Mainland, video booth rental Vancouver, video booth Burnaby, video booth Richmond, video booth Surrey, video booth Coquitlam, audio guestbook alternative Vancouver";

export const SEO_META = {
  "/": {
    title: `${BRAND} — Vintage Video Guestbook Rentals · Lower Mainland`,
    description: "A vintage video guestbook for weddings, birthdays and celebrations across the Lower Mainland. Every guest leaves a message you'll actually rewatch. Check your date.",
  },
  "/how-it-works": {
    title: `How It Works — Video Guestbook Rental | ${BRAND}`,
    description: "Book your date, we set up the vintage video booth, and you get an edited highlight video plus all raw clips within 14 days. 1080p/4K with an external mic.",
  },
  "/packages": {
    title: `Packages & Pricing from $500 | ${BRAND}`,
    description: "Flat, honest pricing for a video guestbook rental in the Lower Mainland: The Short List ($500), The Main Event ($600), The Encore ($700). Travel $5/km beyond 30km, capped at $200.",
  },
  "/gallery": {
    title: `Gallery & Sample Reel | ${BRAND}`,
    description: "See the vintage video booth in action and watch a sample reel of the messages guests leave at weddings and celebrations across the Lower Mainland.",
  },
  "/faq": {
    title: `FAQ — Video Guestbook Questions | ${BRAND}`,
    description: "Booth look, video quality (crisp, high-quality video + external mic), footage rights, travel fees, power needs and delivery times for your Lower Mainland video guestbook rental.",
  },
  "/about": {
    title: `About — A Members' Club for Good Stories | ${BRAND}`,
    description: "The Event Club is a single-operator vintage video guestbook serving weddings and celebrations across the Lower Mainland. A signature fades — a voice doesn't.",
  },
  "/book": {
    title: `Check Your Date — Book a Video Guestbook | ${BRAND}`,
    description: "Send your event details and get a confirmation instantly. We reply within 24 hours with availability and a flat quote for your Lower Mainland celebration.",
  },
  "/metro-vancouver": {
    title: `Coming Soon to Metro Vancouver — Video Guestbook | ${BRAND}`,
    description: "The Event Club's vintage video guestbook is coming soon to Metro Vancouver. Reserve your date early for weddings, birthdays and celebrations across the city.",
  },
};

const DEFAULT = SEO_META["/"];

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function applySEO(pathname) {
  const meta = SEO_META[pathname] || DEFAULT;
  document.title = meta.title;
  upsertMeta("name", "description", meta.description);
  upsertMeta("name", "keywords", KEYWORDS);
  upsertMeta("property", "og:title", meta.title);
  upsertMeta("property", "og:description", meta.description);
  upsertMeta("property", "og:type", "website");
  return meta;
}
